import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { PokeType } from './poke-type.interface';

export class PokeTypeService {
   async getPokeTypes() {
      const response = await http.get<ApiResource<Array<PokeType>>>(`/poke-types`, { ...cacheFirstConfig });
      return response.data;
   }

   async getPokeType() {
      throw Error('Method not implemented');
   }

   async postPokeType() {
      throw Error('Method not implemented');
   }

   async putPokeType() {
      throw Error('Method not implemented');
   }

   async deletePokeType() {
      throw Error('Method not implemented');
   }
}
